export default "__VITE_ASSET__CRh08ysW__"